import ViewController from "./class.ViewController";
import * as ActionUtils from "./Actions/class.ActionUtils";
import TransporterLog from "./class.TransporterLog.js";

const LOGGER = new TransporterLog({
	attributes: {
		name: "TransporterDebug",
		color: "magenta",
	},
});

/**
 * Primitive as heck, but this is just meant for dev use.
 * Should be removed before launch... or something.
 */
export default class TransporterDebug extends ViewController {
	constructor(options) {
		super(options);
		this.buildModal();
		this.buildHotbar();

		if (this.enableDevswag) {
			this.bindSequence(
				[38, 38, 40, 40, 37, 39, 37, 39, 66, 65],
				_.bind(this.showModal, this)
			);
			this.bindSequence(
				[68, 69, 86, 83, 87, 65, 71],
				_.bind(this.showHotbar, this)
			);
		}
	}

	/**
	 * Binds a sequence of keys to a function.
	 * @param {string} phrase
	 * @param {function} callback
	 */
	bindSequence(phrase, callback) {
		var buffer = [];
		$(document).keydown((e) => {
			if (e.which === phrase[buffer.length]) {
				buffer.push(e.which);
			} else if (e.which === phrase[0]) {
				buffer.length = 0;
				buffer.push(e.which);
			} else {
				buffer.length = 0;
			}
			if (buffer.length === phrase.length) {
				buffer.length = 0;
				callback();
			}
		});
	}

	/**
	 * Builds the debug hotbar.
	 */
	buildHotbar() {
		this.$hotbar = $(`<div class="transporter-debug-hotbar"/>`)
			.css({
				position: "fixed",
				display: "flex",
				alignItems: "center",
				top: 0,
				left: 0,
				width: "100%",
				height: "64px",
				zIndex: 9999999,
				backgroundColor: "rgba(0,0,0,0.8)",
				color: "white",
				padding: "10px",
			})
			.hide();
		this.buildHotbarComponents();
		this.mainController.mainView.$el.append(this.$hotbar);

		if (window.location.pathname.indexOf("crypt/composite") > -1) {
			this.$hotbar.fadeIn(200);
		}
	}

	/**
	 * Builds all the hotbar components.
	 */
	buildHotbarComponents() {
		var components = [];
		const runner = this.mainController.runnerController;
		this.devGotoContext = -1;
		var redoIndex = null;
		var $gotoSelect = $(`<select class="goto-select"></select>`);

		this.addCloseButton(components);
		this.addVariableList(components, runner);
		this.addHideAllButton(components);
		this.addRedoButton(components, runner, redoIndex, $gotoSelect);
		this.addGotoSelect(components, runner, redoIndex, $gotoSelect);

		// Append all the components.
		_.each(components, (c) => {
			this.$hotbar.append(c.css("margin-right", "10px"));
		});
	}

	/**
	 * Go to a specific node
	 */
	fakeGoto(index, runner) {
		this.mainController.inputController.disable();
		if (index >= 0) {
			const traverseList = runner
				.createFlowTraverseList(
					[],
					runner.root,
					AoPS.Transporter.CompositeObjectTypes._root.flow
				)
				.slice(index);

			// Traverse the new list.
			runner.traverseFlowTraverseListTop({
				traverseList,
				onAdvance: _.bind(this.mainController.onComplete, this.mainController),
				onBypass: () => {},
				context: this.devGotoContext--,
				$anchor: undefined,
			});
		}
	}

	/**
	 * Add the close button
	 */
	addCloseButton(components) {
		// Close hotbar button.
		var $close = $("<button>X</button>").click((e) => {
			this.hideHotbar();
		});
		components.push($close);
	}

	/**
	 * Add variable list
	 */
	addVariableList(components, runner) {
		// Add the toggle button
		var $varButton = $(
			'<a href="#" class="variable-toggle-link">Variable List <span>-</span> </a>'
		)
			.attr("title", "Toggle Variables")
			.click((e) => {
				this.toggleVariableList($varList, $varButton);
			});

		const varListContent = this.getVarListContent();

		this.varListWrapper = $('<div id="variableListWrapper"></div>');
		this.varListWrapper.append(varListContent);

		// Add the variable list
		var $varList = $(this.varListWrapper);
		components.push($varList);

		// Add the button
		components.push($varButton);
	}

	/**
	 * Gets the content of the variable list
	 * @returns
	 */
	getVarListContent() {
		// Get content wrapper
		let varListContent = $('<div id="variableListContent"></div>');
		let varListDl = $("<dl></dl>");
		varListContent.append(varListDl);

		// Store this as parent for subfunctions
		const parent = this;

		// Add each variable to the list
		$.each(
			this.mainController.transporterVariables.getVariableList(),
			function (key, val) {
				// Get DT tag
				const dt = $("<dt>" + key + ": </dt>");
				varListDl.append(dt);

				// Get DD tag
				const dd = $(
					'<dd data-varname="' +
						key +
						'" contenteditable="true">' +
						val +
						"</dd>"
				);
				parent._attachEditEvents(dd);
				varListDl.append(dd);
			}
		);

		return varListContent;
	}

	setVariable(varName) {
		// Update the debug list in the devswag console
		const varListContent = this.getVarListContent();
		// ignore-security-checks
		this.varListWrapper.html(varListContent);

		// Fade in the color so we see it saving
		$("dd[data-varname='" + varName + "']")
			.css("background-color", "#666666")
			.animate({backgroundColor: "rgba(0, 0, 0, 0)"}, 2000, function () {
				$(this).css("background-color", "");
			});
	}

	/**
	 * Attach the events to the document variable list
	 */
	_attachEditEvents(dd) {
		// Attach blur for when they click away
		dd.on("blur", (e) => {
			this.mainController.transporterVariables.setValue(
				$(e.target).data("varname"),
				$(e.target).text()
			);
		});

		// Also intercept the enter button
		dd.on("keypress", (e) => {
			if (e.key === "Enter") {
				e.preventDefault();
				this.mainController.transporterVariables.setValue(
					$(e.target).data("varname"),
					$(e.target).text()
				);
			}
		});

		return dd;
	}

	/**
	 * Add Hide All Bomb button
	 */
	addHideAllButton(components) {
		// Hide all button
		var $hideAll = $("<button>💣</button>")
			.css({
				marginLeft: "auto",
			})
			.attr("title", "Hide All")
			.click((e) => {
				this.mainController.mainView._unsticky();
				this.mainController.mainView.layoutView.$el
					.html("")
					.siblings()
					.remove();
				this.mainController.mainView.$layoutContainer.css("height", "");
			});
		components.push($hideAll);
	}

	/**
	 * Redo button repeats the last action
	 */
	addRedoButton(components, runner, redoIndex, $gotoSelect) {
		// Redo button
		var $redo = $("<button>🔁</button>")
			.attr("title", "Repeat the last manually selected message.")
			.click((e) => {
				if (_.isNull(redoIndex)) {
					redoIndex = $gotoSelect.prop("selectedIndex");
				}
				this.fakeGoto(redoIndex, runner);
			});
		components.push($redo);
	}

	/**
	 * Add select to jump to node
	 */
	addGotoSelect(components, runner, redoIndex, $gotoSelect) {
		// Goto select
		const body = runner.root.body;
		for (let i = 0; i < body.length; i++) {
			let option = body[i];
			$gotoSelect
				.attr("title", "Goto Select")
				.append(
					$(`<option></option>`)
						.text(`${i} ${option.type} @ ${option.ref}`)
						.attr("value", option.ref)
				);
		}
		$gotoSelect.change((e) => {
			LOGGER.log("Updating redo index.");
			redoIndex = $gotoSelect.prop("selectedIndex");
			this.fakeGoto(redoIndex, runner);
		});
		components.push($gotoSelect);
	}

	/**
	 * Show or hide the list of variables
	 */
	toggleVariableList($list, $button) {
		if ($list.find("#variableListContent").is(":visible")) {
			$list.find("#variableListContent").hide();
			$button.find("span").text("+");
		} else {
			$list.find("#variableListContent").show();
			$button.find("span").text("-");
		}
	}

	/**
	 * Show the debug hotbar.
	 */
	showHotbar() {
		this.$hotbar.fadeIn(200);
	}

	/**
	 * Hide the debug hotbar
	 */
	hideHotbar() {
		this.$hotbar.fadeOut(200);
	}

	/**
	 * Updates the selected option in the hotbar fake goto select.
	 * @param {number} index
	 */
	setFakeGotoHotbar(index) {
		this.$hotbar.find(".goto-select").prop("selectedIndex", index);
	}

	/**
	 * Builds the debug modal
	 */
	buildModal() {
		this.$el
			.css({
				position: "fixed",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				zIndex: 9999999,
				backgroundColor: "rgba(0,0,0,0.8)",
				color: "white",
			})
			.hide();
		this.$el.append('<h1 style="color:hotpink;">~~ Developer Tools ~~</h1>');
		this.$el.append('<h2 style="color:hotpink;">¯\\_(ツ)_/¯</h2>');
		$(document).keydown((e) => {
			if (e.which === 27) {
				this.hideModal();
			}
		});
		this.buildComponents();
		this.mainController.mainView.$el.append(this.$el);
	}

	/**
	 * Builds the debug components
	 */
	buildComponents() {
		var components = [];

		// Re-render question prompts checkbox
		var $questionPrompts = $('<div class="debug-prompts"></div>');
		$questionPrompts
			.append("<label>Re-render question prompts:</label>")
			.append(
				$('<input type="checkbox" name="debug-prompts" />')
					.prop("checked", ActionUtils.getRerenderPrompts())
					.change((e) => {
						LOGGER.log("rerenderPrompts changed to " + e.target.checked);
						ActionUtils.setRerenderPrompts(e.target.checked);
					})
			);
		components.push($questionPrompts);

		// Scroll sticky threshold
		var $stickyThreshold = $('<div class="sticky-threshold"></div>');
		$stickyThreshold
			.append("<label>Scroller sticky threshold (px):</label>")
			.append(
				$('<input type="number" name="sticky-threshold" min="0" max="1000"/>')
					.val(this.mainController.mainView.stickyThreshold)
					.change((e) => {
						LOGGER.log("stickyThreshold changed to " + $(e.target).val());
						this.mainController.mainView.stickyThreshold = $(e.target).val();
					})
			);
		components.push($stickyThreshold);

		// Input save/load
		var $inputLoader = $('<div class="input-loader"></div>');
		var $saveInput = $('<button name="save-input">Get Input Buffer</button>');
		$saveInput
			.click((e) => {
				$stateTextArea.val(
					JSON.stringify(this.mainController.inputController.save())
				);
			})
			.appendTo($inputLoader);
		var $loadInput = $('<button name="load-input">Load Input Queue</button>');
		$loadInput
			.click((e) => {
				this.mainController.inputController.load(
					JSON.parse($stateTextArea.val())
				);
				this.mainController.inputController.request();
			})
			.appendTo($inputLoader);
		var $stateTextArea = $('<textarea name="state-text"></textarea>')
			.css({
				display: "block",
				width: "75vw",
				height: "200px",
				backgroundColor: "rgba(0, 0, 0, 0.2)",
				color: "white",
			})
			.appendTo($inputLoader);
		components.push($inputLoader);

		// Append all the components.
		_.each(components, (c) => {
			this.$el.append(c.css("margin-bottom", "10px"));
		});
	}

	/**
	 * Shows the modal
	 */
	showModal() {
		this.$el.fadeIn(200);
	}

	/**
	 * Hides the modal
	 */
	hideModal() {
		this.$el.fadeOut(200);
	}
}
